






import { Vue, Component, Prop } from 'vue-property-decorator'

@Component
export default class Subtext extends Vue {
  @Prop({ type: String, default: '' }) readonly color?: string
}
